(function (window, $, psw) {
    "use strict";

    $("#request-more-information").submit(function (e) {
        e.preventDefault();

        var form = $(this);
        if (!form.valid()) {
            return false;
        }

        // Execute Turnstile and submit form
        psw.executeTurnstile(function (token) {
            $.ajax({
                url: psw.api("/pardot/postall"),
                type: "POST",
                data: form.serialize() +
                    "&url=" +
                    encodeURIComponent("https://go.pardot.com/l/27442/2014-04-23/3fqbgr") +
                    "&hash=" +
                    encodeURIComponent("tZL85MSjTK4PJNIcdg73lIysyotv5/cxeyn/FCn1vUw=") +
                    "&turnstileToken=" +
                    encodeURIComponent(token),
                success: function (result) {
                    if (result && result.redirect) {
                        window.location.href = result.redirectLocation;
                    }
                },
                error: function () {
                    psw.alerts.error('Something went wrong and we could not send your request. Sorry for the extra work. Please <a href="https://customers.particular.net">contact support</a> instead.', false);
                },
            });
        });
    });
})(window, jQuery, psw);
